import { render, staticRenderFns } from "./CampaignAccessRulesCell.vue?vue&type=template&id=2f6bfd84&scoped=true"
import script from "./CampaignAccessRulesCell.vue?vue&type=script&lang=js"
export * from "./CampaignAccessRulesCell.vue?vue&type=script&lang=js"
import style0 from "./CampaignAccessRulesCell.vue?vue&type=style&index=0&id=2f6bfd84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6bfd84",
  null
  
)

export default component.exports